import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';

import { Schedule, Property, PopOut, Button } from 'components'
import { ScheduleInput, TagInput, TagBlock } from 'features'
import { tagContext } from 'context'
import { FaCalendar } from 'react-icons/fa'

import { scheduleString, formatItemDatetime, datetimeString } from 'utils'
import { Item } from 'schema'
import * as actionCreators from 'store/actions'

const Container = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 0.5rem;
`

const Row = styled.div`
    display: grid;
    grid-template-columns: 5rem auto;
`

const Block = styled.div`
    padding: 0.2rem;
    cursor: pointer;
    background-color: var(--primary-color);
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    border-radius: 5px;
    :hover{
        filter: brightness(var(--brightness));
    }
`

const Label = styled.div`
    border-radius: 5px;
    padding:${props => props.padding || '0.5rem'};
    background-color: var(--primary-color);
    color: var(--secondary-accent-color);
    font-size: 0.8rem;
    font-weight: bold;
    display: flex;
    align-items: center;
    align-self: flex-start;
    /* Use when allow add properties to item */
    /* :hover{
        filter: brightness(var(--brightness));
    } */
`

class ItemProperties extends Component {
    setSchedule = (schedule) => {
        let updatedItem = {...this.props.item}
        const alert = this.props.item.getAlert()      
        const hasSchedule = schedule['startDate'] || schedule['endDate'] || schedule['startTime'] || schedule['endTime'] ? true : false

        updatedItem['start_date'] = schedule['startDate']
        updatedItem['end_date'] = schedule['endDate']
        updatedItem['start_time'] = schedule['startTime']
        updatedItem['end_time'] = schedule['endTime']
        updatedItem = formatItemDatetime(updatedItem)
        

        // Add alert
        if(hasSchedule){
            const refDate = schedule['startTime'] || schedule['endTime'] || schedule['startDate'] || schedule['endDate']
            const subtitle = datetimeString(refDate, alert.type)
            const date = datetimeString(refDate)
            const id = uuidv4()
            const toast = {
                id: id,
                title: this.props.item.getPlainText(),
                subtitle: subtitle,
                date: date,
                secID: {id: this.props.item.itemID, relation: 'item'},
                data: {
                    item: {
                        itemID: this.props.item.itemID, 
                        parents: this.props.item.parents, 
                        sectionID: this.props.item.sectionID, 
                        pageID: this.props.item.pageID
                    }
                }
            }
            updatedItem['alerts'] = {}
            updatedItem['alerts'][id] = toast
        } else {
            updatedItem['alerts'] = null
        }
        // console.log(updatedItem)
        this.props.updateItem(updatedItem, this.props.data, this.props.uid, this.props.sessionId)
    }

    render() {
        let properties = {}
        // Dates
        const itemDates = {
            start_date: this.props.item['start_date'],
            end_date: this.props.item['end_date'],
            start_time: this.props.item['start_time'],
            end_time: this.props.item['end_time']
        }
        
        const schedule = scheduleString(itemDates, this.props.user['timezone']);
        if(schedule.valid){
            properties['schedule'] = <Property key={uuidv4()} tooltip='Schedule' label={<Schedule dates={{start: schedule.start, end: schedule.end}}/>}/>
        }

        // Tags
        const tags = this.props.data['tags']
        const tagIDs = this.props.item.tags
        const tagBlocks = []
        if(tagIDs){
            Object.values(tagIDs).map(tagID => {
                const tag = tags[tagID]
                tag && tagBlocks.push(<TagBlock key={uuidv4()} tag={tag} style={{margin: '0.2rem',cursor:'pointer'}}/>)
            })
            properties['tags'] = tagBlocks
        }

        // Schedule input
        const dates = {
            start_date: this.props.item.start_date ? new Date(this.props.item.start_date) : null,
            end_date: this.props.item.end_date ? new Date(this.props.item.end_date) : null, 
            start_time: this.props.item.start_time ? new Date(this.props.item.start_time) : null,
            end_time: this.props.item.end_time ? new Date(this.props.item.end_time) : null
        }

        return (
            <Container>
                <Row>
                    <Label>Schedule</Label>
                    <PopOut trigger='leftClick' animation='default' 
                        element={<ScheduleInput schedule={dates} onSubmit={this.setSchedule}/>}
                        onClose={() => this.props.setInput(null)}
                        onOpen={() => this.props.setInput(`${this.props.item.itemID}_ScheduleInput`)}>
                        <Block>{properties['schedule'] || <Label padding='0.3rem'>Empty</Label>}</Block>
                    </PopOut>
                </Row>

                <Row>
                    <Label>Tags</Label>
                    <PopOut trigger='leftClick' animation='default' 
                        element={<TagInput item={this.props.item}/>}
                        onClose={() => this.props.setInput(null)}
                        onOpen={() => this.props.setInput(`${this.props.item.itemID}_TagInput`)}>
                        <Block>{properties['tags'].length > 0 ? properties['tags'] : <Label padding='0.3rem'>Empty</Label>}</Block>
                    </PopOut>
                </Row>

                {/* <Button text='+ Add property' styles={{backgroundColor:'var(--primary-color)', color: 'var(--secondary-accent-color)',width: 'fit-content', margin: 0, padding: '0.2rem'}}contextMenu={<div>hello</div>}/> */}
            </Container>
        )
    }
}

const mapStateToProps = state => {
    return {
        uid: state.auth.uid,
        user: state.auth.user,
        data: state.db.present.data && state.db.present.data.toJS(),
        activePageID: state.auth.activePageID,
        inputID: state.content.inputID,
        sessionId: state.content.sessionId
    }
};

const mapDispatchToProps = dispatch => {
    return {
        updateItem: (item, data, uid, sessionId) => dispatch(actionCreators.updateItem(item, data, uid, sessionId)),
        setInput: (inputID) => dispatch(actionCreators.setInput(inputID)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ItemProperties);

ItemProperties.propTypes = {
    item: PropTypes.instanceOf(Item)
}

